import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {ProService} from '../../../services/pro.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';

@Injectable()
export class MspRegionPaymentEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private proService = inject(ProService);

  constructor() {}

  GetMspPaymentRegions$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.GetMspRegionPayment),
    map((action: featureActions.GetMspRegionPayment) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionId: payload.RegionId
      };
      return this.proService.ReadProPaymentSetting(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetMspRegionPaymentSuccess(res.msg.body)];
          } else {
            return of(new featureActions.GetMspRegionPaymentFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspPaymentSetting
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  UpdateMspRegionPayment$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.UpdateMspRegionPayment),
    map((action: featureActions.UpdateMspRegionPayment) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        ...payload,
        otp: user.otp
      };
      return this.proService.UpdateProPaymentSetting(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.UpdateMspPaymentSetting };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateMspCompany
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  GetMspPaymentSettingByDistributor$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributor),
    map((action: featureActions.GetMspPaymentSettingByDistributor) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionId: payload.RegionId
      };
      return this.proService.ReadProPaymentSettingByDistributor(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetMspPaymentSettingByDistributorSuccess(res.msg.body)];
          } else {
            return of(new featureActions.GetMspPaymentSettingByDistributorFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspPaymentSettingByDistributor
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  ReadMspPaymentDocumentList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.ReadMspPaymentDocumentList),
    map((action: featureActions.ReadMspPaymentDocumentList) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        ...payload,
        otp: user.otp,
      };
      return this.proService.ReadProPaymentDocumentList(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMspPaymentDocumentListSuccess(res.msg.body)];
          } else {
            return of(new featureActions.ReadMspPaymentDocumentListFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspPaymentDocumentList
          };
          return [new featureActions.UpdateInfoFailAction()];
        })
      );
    })
  ));
  ReadMspPaymentDocument$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.ReadMspPaymentDocument),
    map((action: featureActions.ReadMspPaymentDocument) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        DocId: payload.DocId
      };
      return this.proService.ReadProPaymentDocument(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMspPaymentDocumentSuccess(res.msg.body)];
          } else {
            return of(new featureActions.ReadMspPaymentDocumentFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspPaymentDocument
          };
          return [new featureActions.UpdateInfoFailAction()];
        })
      );
    })
  ));
  UpdateMspPaymentDocument$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.UpdateMspPaymentDocument),
    map((action: featureActions.UpdateMspPaymentDocument) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMspPaymentDocument
      };
      const params = {
        ...payload,
        otp: user.otp
      };
      return this.proService.UpdateProPaymentDocument(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const finalUpdateRes = { ...updateRes, result: true };
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction(finalUpdateRes)];
          } else {
            return [new featureActions.UpdateInfoFailAction(finalUpdateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'Error' })];
        })
      );
    })
  ));
  GenerateMspPaymentDocument$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.GenerateMspPaymentDocument),
    map((action: featureActions.GenerateMspPaymentDocument) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        ...payload,
        otp: user.otp
      };
      return this.proService.GenerateProPaymentDocument(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.GenerateMspPaymentDocument };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result),
              new featureActions.ReadMspPaymentDocumentList({RegionId: payload.RegionId}),
              new featureActions.ReadMspDeviceUsageList(
                { otp: '',
                  RegionId: payload.RegionId,
                  UnitPrice: payload.UnitPrice,
                  UsageDate: payload.DocDate
                })
              ];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.GenerateMspPaymentDocument
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  ReadMspDeviceUsageList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.ReadMspDeviceUsageList),
    map((action: featureActions.ReadMspDeviceUsageList) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionId: payload.RegionId,
        UsageDate: payload.UsageDate,
        IsDistributorAll: payload.IsDistributorAll
      };
      return this.proService.ReadProDeviceUsageList(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const item = {
              body: res.msg.body,
              UnitPrice: payload.UnitPrice !== null ? payload.UnitPrice : 0,
              RegionId: payload.RegionId,
            };
            return [new featureActions.ReadMspDeviceUsageListSuccess(item)];
          } else {
            return of(new featureActions.ReadMspDeviceUsageListFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspDeviceUsageList
          };
          return [new featureActions.UpdateInfoFailAction()];
        })
      );
    })
  ));
  ReadMspDeviceUsage$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MspRegionPaymentActionTypes.ReadMspDeviceUsage),
    map((action: featureActions.ReadMspDeviceUsage) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionId: payload.RegionId,
        IsDetail: payload.IsDetail
      };
      return this.proService.ReadProDeviceUsage(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMspDeviceUsageSuccess(res.msg.body)];
          } else {
            return of(new featureActions.ReadMspDeviceUsageFail());
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ReadMspDeviceUsage
          };
          return [new featureActions.UpdateInfoFailAction()];
        })
      );
    })
  ));
}

